import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import DashboardLayout from "../DashboardLayout";
import { ArrowLeft } from "lucide-react";
import NewsletterSection from "../newsletter/NewsletterSection";

const DemoShell = ({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}) => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>{title} | OpenPipe</title>
        {description && <meta name="description" content={description} />}
      </Helmet>
      <div className="w-full max-w-3xl mx-auto pt-6 pb-12">
        {/* <Link
          to="/demos"
          className="inline-flex items-center mb-6 md:mb-10 text-sm text-muted-foreground hover:text-primary transition-colors"
        >
          <ArrowLeft size={16} className="mr-2" />
          See other demos
        </Link> */}

        {children}

        <div className="text-center mt-10 md:mt-16 mb-12">
          <h3 className="text-lg md:text-xl font-medium mb-4 md:mb-6">
            Enjoy this demo? Join our newsletter to hear about others.
          </h3>
          <div className="max-w-2xl mx-auto">
            <NewsletterSection hideHeading={true} />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DemoShell;
